<script lang="ts">
    import Panel from "../materialize/components/Panel.svelte";
    import WordSearchForm from "./subcomponents/WordSearchForm.svelte";
    import { fade } from "svelte/transition";
import AudioRecordButton from "../utils/AudioRecordButton.svelte";
import Column from "../materialize/grid/Column.svelte";
import ShareButton from "../utils/ShareButton.svelte";
import { BASE_URL_SHARE, get_host } from "../settings";
</script>

<div in:fade>
        <div class="row valign-wrapper">
            <Column small={4} medium={2} large={2} extra_large={1}>
                <img src="/favicon.png" alt="" class="circle responsive-img">
            </Column>
            <Column small={8} medium={8} large={10} extra_large={11}>
                <h1 class="center-align">Appröu</h1>
                <h5 class="center-align">I dialetti di oggi sempre con te</h5> 
            </Column>
          </div>
    <Panel class_list={[]}>
        <h4>Cerca parola</h4>
        <WordSearchForm />
    </Panel>
    <!-- <ShareButton button_flat={true} button_text="Invita un amico" share_title="Appröu dizionario" share_url="{BASE_URL_SHARE}" share_text={`Scopri il dizionario dialettale su ${BASE_URL_SHARE}`}></ShareButton> -->
</div>

<style>
</style>

